import React, {Component} from 'react'
import ErrorBoundary from './ErrorBoundary'
import {connect} from 'react-redux'
import {
    handleInit,
    translationsDataSelector,
    translationsLocaleSelector,
    hadLoginSessionSelector,
    handleSetAppData,
    wasOfflineSelector
} from '../modules/app'
import {profileLoadStateSelector, isOrganisationSelector} from '../modules/profile'
import { Route, Redirect, Switch } from 'react-router-dom'
import Loader from './common/Loader'
import QuestionsPage from './routes/QuestionsPage'
import DashboardPage from './routes/DashboardPage'
import ProfilePage from './routes/ProfilePage'
import PaymentPage from './routes/PaymentPage'
import SupportPage from './routes/SupportPage'
import NotFoundPage from './routes/NotFoundPage'
import AdminPanelPage from './routes/AdminPanelPage'
import AuthPage from './routes/AuthPage'
import AdminRoute from './routes/AdminRoute'
import AuthRoute from './routes/AuthRoute'
import ModalRoot from './ModalRoot'
import ForbidClickLayer from './common/ForbidClickLayer'
import {IntlProvider} from 'react-intl'
import 'react-quill/dist/quill.snow.css'
import 'react-select/dist/react-select.css'
import {NO_ACTION_SECONDS_LOGOUT, logout} from '../modules/app'
import moment from 'moment'
import 'moment-timer'
import {throttle} from '../helpers/common'
import TutorialRoot from './tutorial/TutorialRoot'
import {routesUrls} from '../settings/routes'
import NotAuthRoute from "./routes/NotAuthRoute"
import RoomsAndStudentsPage from './routes/RoomsAndStudentsPage'
import StudentsPage from './routes/StudentsPage'
import QuizsPage from './routes/QuizsPage'
import QuizPage from './routes/QuizPage'
import StatisticReportsPage from './routes/StatisticReports'
import StudentAnswerQuizPage from './routes/StudentAnswerQuizPage'
import PresentationsPage from './routes/PresentationsPage'
import PresentationsStartPage from './routes/PresentationsStartPage'
import PresentationPage from './routes/PresentationPage'
import PaymentModal from './PaymentModal'
import TransactionPage from './Transaction'
import HandleReset from './common/Auth/HandleReset'
import HandleConfirm from './common/Auth/HandleConfirm'
import UserOrganisation from './UserOrganisation'
import Trashed from './Trashed'
import CardPage from './routes/CardPage'
import CardPageView from './routes/CardPageView'
import CardTrashedPage from './routes/CardTrashedPage'
import Referals from './AdminPanel/Referals/Referals'
import QuestionImportPage from './routes/QuestionImportPage'
import QuestionPageView from './routes/QuestionPageView'
import QuestionPage from './routes/QuestionPage'
import QuestionMultyView from './QuestionMultyView/QuestionMultyView'
import SlidersPage from './routes/SlidersPage'
import SliderPage from './routes/SliderPage'
import SliderVIew from './SliderVIew/SliderVIew'


class App extends Component {

    state = {
        deferredInitLoading : true,
        deferredTimePassed : 0,
    }
    render() {

        const {locale, translations, isOrganisation} = this.props
        const {deferredInitLoading} = this.state

        if (deferredInitLoading) return <Loader className = "full-screen-fixed preloader-theme" isLogoPreloader />
        return (
                <ErrorBoundary>
                    <IntlProvider
                        locale = {locale}
                        messages = {translations}
                    >
                        <React.Fragment>
                            <Switch>
                                <Route path = {routesUrls.card_view} component = {CardPageView} />
                                <Route path = {routesUrls.question} component = {QuestionPageView} />
                                <Route path = {routesUrls.question_multy_view} component = {QuestionMultyView} />
                                <Route path = {routesUrls.slider_view} component = {SliderVIew} />
                                <AuthRoute path = {routesUrls.student_answer_quiz} component = {StudentAnswerQuizPage} />
                                
                                <AuthRoute path = {routesUrls.dashboard} exact component = {isOrganisation ? UserOrganisation : DashboardPage} />
                                
                                <AuthRoute path = {routesUrls.rooms_students} exact component = {RoomsAndStudentsPage} />
                                <AuthRoute path = {routesUrls.students} exact component = {StudentsPage} />

                                <AuthRoute path = {routesUrls.quiz} component = {QuizPage} />
                                <AuthRoute path = {routesUrls.quizs} exact component = {QuizsPage} />
                                <AuthRoute path = {routesUrls.sliders} exact component = {SlidersPage} />
                                <AuthRoute path = {routesUrls.slider} component = {SliderPage} />

                                <AuthRoute path = {routesUrls.trashed} exact component = {Trashed} />
                                
                                <AuthRoute path = {routesUrls.questions} exact component = {QuestionsPage} />

                                <AuthRoute path = {routesUrls.presentations} component = {PresentationsPage} />
                                <AuthRoute path = {routesUrls.card} component = {CardPage} />
                                <AuthRoute path = {routesUrls.questions_multy} component = {QuestionPage} />
                                <AuthRoute path = {routesUrls.question_import} component = {QuestionImportPage} />
                                <AuthRoute path = {routesUrls.card_trashed} component = {CardTrashedPage} />
                                <AuthRoute path = {routesUrls.presentation} component = {PresentationPage} />
                                <AuthRoute path = {routesUrls.presentations_start} component = {PresentationsStartPage} />

                                <AuthRoute path = {routesUrls.statistic_reports} component = {StatisticReportsPage} />
                                
                                <AuthRoute path = {routesUrls.profile} component = {ProfilePage} />
                                <AuthRoute path = {routesUrls.payment} component = {PaymentPage} />
                                <AuthRoute path = {routesUrls.support} component = {SupportPage} />
                                <AuthRoute path = {routesUrls.transactions} component = {TransactionPage} />
                                <AuthRoute path = {routesUrls.referals} component = {Referals} />
                                
                                <Route path = {routesUrls.confirm} component = {HandleConfirm} />
                                <NotAuthRoute path = {routesUrls.auth} component = {AuthPage} />
                                <AdminRoute path = {routesUrls.admin} component = {AdminPanelPage} />
                                <Route path = '/404' component = {NotFoundPage} />
                                <Route path = '*' component = {() => <Redirect to="/404" />} />
                            </Switch>
                            <ModalRoot />
                            <TutorialRoot />
                            <ForbidClickLayer />
                            <PaymentModal />
                        </React.Fragment>
                    </IntlProvider>
                </ErrorBoundary>
        )
    }

    componentDidMount() {
        window.state = {};
        window.tempState = 0;
        const {handleInit} = this.props
        handleInit()
        this.initDeferredLoadingCheck()
        this.listenToSession()
    }

    initDeferredLoadingCheck = () => {
        this.timerId = setInterval(() => {
            if (this.checkClearDeferredInitLoading()) {
                this.clearDeferredInitLoading()
            }
            this.setState(({deferredTimePassed}) => ({deferredTimePassed : deferredTimePassed + App.INTERVAL}))
        }, App.INTERVAL)
    }

    checkClearDeferredInitLoading = () => {
        const {profileLoading, profileLoaded, hadLoginSession} = this.props
        const time = hadLoginSession ? App.MIN_DEFERRED_LOADING : App.MAX_DEFERRED_LOADING
        return (profileLoaded || !profileLoading) && (this.state.deferredTimePassed >= time)
    }

    clearDeferredInitLoading = () => {
        const {handleSetAppData} = this.props
        this.setState(() => ({deferredInitLoading : false}), () => {
            clearInterval(this.timerId)
            handleSetAppData({hadLoginSession : true})
        })
    }


    //TODO: logout timer

    idleLogoutTimer = throttle((event) => {
        if (this.timer && typeof this.timer.stop === 'function') this.timer.stop()
        this.timer = moment.duration(NO_ACTION_SECONDS_LOGOUT, "seconds").timer(() => {
            this.props.logout({expired : {timeout:true}})
        })
    }, 5000)

    /*
    * https://stackoverflow.com/a/24989958
    * */
    listenToSession = () => {
        // let events = ['mousemove', 'mousedown', 'touchstart', 'click', 'keypress']
        // events.forEach(event => {
        //     window.addEventListener(event, this.idleLogoutTimer)
        // })
        // window.addEventListener('scroll', this.idleLogoutTimer, true)

        // window.addEventListener('offline', this.handleOffline)
        // window.addEventListener('online', this.handleOnline)
    }

    handleOffline = () => {
        const {handleSetAppData} = this.props
        handleSetAppData({wasOffline : true})
    }
    handleOnline = () => {
        const {wasOffline, logout} = this.props
        if (wasOffline) logout({expired : {timeout:false}})
    }

    static INTERVAL = 1000
    static MIN_DEFERRED_LOADING = 1000 // ms
    static MAX_DEFERRED_LOADING = 8000 // ms
}

export default connect(
    state => {
        const {loading : profileLoading, loaded : profileLoaded} = profileLoadStateSelector(state)
        let locale = translationsLocaleSelector(state)
        return {
            profileLoading,
            profileLoaded,
            translations : translationsDataSelector(state),
            locale,
            hadLoginSession : hadLoginSessionSelector(state),
            wasOffline : wasOfflineSelector(state),
            isOrganisation : isOrganisationSelector(state),
        }
    },
    {handleInit, handleSetAppData, logout},
    null,
    {pure : false}
)(App)



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/App.js